// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"205":"DokumenIndex","268":"Home","887":"BannerIndex"}[chunkId] + "." + {"205":"7db5da6d","268":"86b778e6","887":"8c1a7c5e"}[chunkId] + ".css";
};